var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"psPatientDiseases"},[_c('div',{staticClass:"row rowTitle"},[_vm._v(" Enfermedades de base / Momento biológico "),_c('ps-patient-btn-new-disease')],1),_c('div',{staticClass:"row rowTags"},_vm._l((_vm.patient.diseases),function(disease,index){return _c('el-tag',{key:index},[_vm._v(_vm._s(disease.diseaseDescription))])}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }